var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viewer-list" },
    [
      _vm.property.objectId ? _c("buildings") : _vm._e(),
      _vm._v(" "),
      _c("panoramas"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }